import "./utilities_namespace.js";
import "./url_modifier.js";
import "../../shared/events.js";

// Imports ./url_modifier, not ./locale: localizeUrl resolves through
// modifyUrlParams at call time, and url_modifier imports ./locale itself.
// Importing only ./locale here leaves bundles like embed/snippet.js without
// modifyUrlParams, crashing localized fetches at runtime.

// Fetches content from an endpoint and injects it into the element
// This will be removed when the doctor finder includes its own HTML templates

window.Sparkle ??= {};
window.Sparkle.Embed ??= {};
window.Sparkle.Embed.Utilities ??= {};

Sparkle.Embed.Utilities.fetchRemoteContent = function (url, target) {
  target = jQuery(target);
  url = Sparkle.Embed.Utilities.localizeUrl(url); // Render remote content in the host page's language

  const promise = jQuery.ajax({
    url: url,
    dataType: "html",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  const assetPromise = promise.then((content) => {
    return Sparkle.Embed.Utilities.preloadRemoteAssets(content);
  });

  const loaded = assetPromise
    .then((content) => {
      target.append(content);
      Sparkle.Events.contentUpdated(target[0]); // Notify
      Sparkle.Embed.Utilities.scrollToAnchorFromParams();
    })
    .always(function () {
      return promise;
    });

  return loaded;
};

// When HTML content is added to the DOM via AJAX, remote stylesheets and scripts do not block rendering like they do
// when part of the DOM on the initial page load. This can cause a flash of unstyled content (FOUC) as assets are
// loaded after the HTML is visible. This method can be used to delay rendering of the HTML in the block until the
// assets in the block have preloaded. To avoid never loading the content if something goes wrong, after the given
// timeout, content will be shown regardless of preload status.
Sparkle.Embed.Utilities.preloadRemoteAssets = function (html, timeout = 2000) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const scripts = doc.querySelectorAll("script[src]");
  const styles = doc.querySelectorAll('link[rel="stylesheet"]');
  let remainingAssets = 0;
  let complete = false;
  const deferred = new jQuery.Deferred(); // Use a jQuery Deferred because jQuery 1.x doesn't support chaining native Promise

  // INITIALIZE

  setTimeout(stopWaiting, timeout);
  preloadRemoteScripts(scripts);
  preloadRemoteStyles(styles);

  if (remainingAssets <= 0) {
    // Load immediately if there was nothing to preload
    allAssetsLoaded();
  }

  return deferred.promise();

  // HELPER FUNCTIONS

  function preloadRemoteScripts(scripts) {
    scripts.forEach(function (script) {
      if (script.src) {
        createPreload(script.src, "script");
      }
    });
  }

  function preloadRemoteStyles(styles) {
    styles.forEach(function (style) {
      if (style.href) {
        createPreload(style.href, "style");
      }
    });
  }

  function createPreload(src, as) {
    var link = document.createElement("link");
    waitForPreload(link);
    link.rel = "preload";
    link.as = as;
    link.href = src;
    document.head.appendChild(link);
  }

  function waitForPreload(link) {
    remainingAssets++;
    link.addEventListener("load", assetLoadedCallback, { once: true });
  }

  // Decrement the remaining asset counter and resolve the assets loaded promise if all the assets are preloaded
  function assetLoadedCallback() {
    if (--remainingAssets <= 0) {
      allAssetsLoaded();
    }
  }

  function stopWaiting() {
    if (!complete) {
      console.warn("Showing content before preloading due to latency");
      allAssetsLoaded();
    }
  }

  function allAssetsLoaded() {
    complete = true;
    deferred.resolve(html);
  }
};

Sparkle.Embed.Utilities.scrollToAnchorFromParams = function () {
  if (!(window.scrollX == 0 && window.scrollY == 0)) {
    return;
  }

  const anchorName = window.location.hash.slice(1);
  if (!anchorName) {
    return;
  }

  const anchorElement = document.getElementById(anchorName);

  if (anchorElement) {
    anchorElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
